import { z } from "zod";

export const defaultPlanSchema = () => {
  return z.object({
    name: z.string().min(1),
    description: z.string().optional().nullable(),
    access_amount: z.any().optional().nullable(),
    value: z.any().optional().nullable(),
    vindi_page: z.any().optional().nullable(),
    vindi_token: z.any().optional().nullable(),
    audiobook_quantity: z.any().optional().nullable(),
    book_quantity: z.any().optional().nullable(),
    magazine_quantity: z.any().optional().nullable(),
    plan_types: z.array(z.string()).optional().nullable(),
    level: z.number().optional().nullable(),
  });
};

export type DefaultPlanFormValues = z.infer<ReturnType<typeof defaultPlanSchema>>;
